// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/arbitrum-nova-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RPCResponse } from './RPCResponse';
import {
    RPCResponseFromJSON,
    RPCResponseFromJSONTyped,
    RPCResponseToJSON,
} from './RPCResponse';
import type { RPCResponseError } from './RPCResponseError';
import {
    RPCResponseErrorFromJSON,
    RPCResponseErrorFromJSONTyped,
    RPCResponseErrorToJSON,
} from './RPCResponseError';
import type { RPCResponseId } from './RPCResponseId';
import {
    RPCResponseIdFromJSON,
    RPCResponseIdFromJSONTyped,
    RPCResponseIdToJSON,
} from './RPCResponseId';

/**
 * 
 * @export
 * @interface DoRpcRequest200Response
 */
export interface DoRpcRequest200Response {
    /**
     * 
     * @type {string}
     * @memberof DoRpcRequest200Response
     */
    jsonrpc: DoRpcRequest200ResponseJsonrpcEnum;
    /**
     * 
     * @type {RPCResponseId}
     * @memberof DoRpcRequest200Response
     */
    id: RPCResponseId;
    /**
     * 
     * @type {any}
     * @memberof DoRpcRequest200Response
     */
    result?: any | null;
    /**
     * 
     * @type {RPCResponseError}
     * @memberof DoRpcRequest200Response
     */
    error?: RPCResponseError;
}


/**
 * @export
 */
export const DoRpcRequest200ResponseJsonrpcEnum = {
    _20: '2.0'
} as const;
export type DoRpcRequest200ResponseJsonrpcEnum = typeof DoRpcRequest200ResponseJsonrpcEnum[keyof typeof DoRpcRequest200ResponseJsonrpcEnum];


/**
 * Check if a given object implements the DoRpcRequest200Response interface.
 */
export function instanceOfDoRpcRequest200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jsonrpc" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function DoRpcRequest200ResponseFromJSON(json: any): DoRpcRequest200Response {
    return DoRpcRequest200ResponseFromJSONTyped(json, false);
}

export function DoRpcRequest200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DoRpcRequest200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jsonrpc': json['jsonrpc'],
        'id': RPCResponseIdFromJSON(json['id']),
        'result': !exists(json, 'result') ? undefined : json['result'],
        'error': !exists(json, 'error') ? undefined : RPCResponseErrorFromJSON(json['error']),
    };
}

export function DoRpcRequest200ResponseToJSON(value?: DoRpcRequest200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jsonrpc': value.jsonrpc,
        'id': RPCResponseIdToJSON(value.id),
        'result': value.result,
        'error': RPCResponseErrorToJSON(value.error),
    };
}

